const ExternalRoute = [
  {
    path: '/event/:event_slug',
    name: 'event',
    redirect: (to) => {
      return (window.location.href =
        process.env.VUE_APP_ACADEMY_URL + '/event/' + to.params.event_slug)
    },
  },
]

export default ExternalRoute
